export function VectorRYPlogo({
  height = 29,
  color = '#fff',
}: {
  height?: number;
  color?: string;
}) {
  return (
    <svg
      width={136 * (height / 29)}
      height={height}
      viewBox="0 0 136 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M131.141 23.0001V5.6001H134.621V23.0001H131.141Z" fill={color} />
      <path
        d="M28.7353 9.896C25.0393 9.896 22.6153 12.032 22.6153 15.92V23H26.0953V15.776C26.0953 14.072 27.0313 13.136 28.7353 13.136C30.4393 13.136 31.3753 14.072 31.3753 15.776V23H34.8553V15.92C34.8553 12.032 32.4313 9.896 28.7353 9.896Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.5325 16.592C48.5325 20.528 51.3165 23.288 55.2525 23.288C59.1885 23.288 61.9725 20.528 61.9725 16.592C61.9725 12.656 59.1885 9.896 55.2525 9.896C51.3165 9.896 48.5325 12.656 48.5325 16.592ZM58.4925 16.592C58.4925 18.632 57.1485 20.048 55.2285 20.048C53.3325 20.048 52.0125 18.632 52.0125 16.592C52.0125 14.552 53.3565 13.112 55.2525 13.112C57.1485 13.112 58.4925 14.552 58.4925 16.592Z"
        fill={color}
      />
      <path
        d="M69.771 23.288C66.147 23.288 63.675 21.104 63.675 17.888V10.28H67.155V17.432C67.155 19.256 68.115 20 69.771 20C71.499 20 72.435 19.256 72.435 17.432V10.28H75.915V17.888C75.915 21.104 73.419 23.288 69.771 23.288Z"
        fill={color}
      />
      <path
        d="M77.76 16.256C77.76 12.296 79.752 10.28 83.64 10.28H84.72V13.52H83.928C81.888 13.52 81.24 14.24 81.24 16.256V23H77.76V16.256Z"
        fill={color}
      />
      <path
        d="M38.7518 26.84L40.2158 22.88L34.8638 10.28H38.6078L41.9918 18.824L45.0158 10.28H48.6638L42.3758 26.84H38.7518Z"
        fill={color}
      />
      <path
        d="M14.6263 23.288C11.0023 23.288 8.53031 21.104 8.53031 17.888V10.28H12.0103V17.432C12.0103 19.256 12.9703 20 14.6263 20C16.3543 20 17.2903 19.256 17.2903 17.432V10.28H20.7703V17.888C20.7703 21.104 18.2743 23.288 14.6263 23.288Z"
        fill={color}
      />
      <path
        d="M5.88 10.28C1.992 10.28 0 12.296 0 16.256V23H3.48V16.256C3.48 14.24 4.128 13.52 6.168 13.52H6.96V10.28H5.88Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.902 16.5921C115.902 20.5281 118.686 23.2881 122.622 23.2881C126.558 23.2881 129.342 20.5281 129.342 16.5921C129.342 12.6561 126.558 9.8961 122.622 9.8961C118.686 9.8961 115.902 12.6561 115.902 16.5921ZM125.862 16.5921C125.862 18.6321 124.518 20.0481 122.598 20.0481C120.702 20.0481 119.382 18.6321 119.382 16.5921C119.382 14.5521 120.726 13.1121 122.622 13.1121C124.518 13.1121 125.862 14.5521 125.862 16.5921Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.622 23.2881C103.687 23.2881 100.902 20.5281 100.902 16.5921C100.902 12.6561 103.687 9.8961 107.622 9.8961C111.558 9.8961 114.342 12.6561 114.342 16.5921C114.342 20.5281 111.558 23.2881 107.622 23.2881ZM107.598 20.0481C109.519 20.0481 110.862 18.6321 110.862 16.5921C110.862 14.5521 109.518 13.1121 107.622 13.1121C105.726 13.1121 104.382 14.5521 104.382 16.5921C104.382 18.6321 105.702 20.0481 107.598 20.0481Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.072 16.3521C86.024 17.0721 86 17.6961 86 18.6561V26.8401H89.456V21.6081C90.224 22.6161 91.52 23.1921 93.152 23.1921C96.656 23.1921 99.344 20.4321 99.344 16.7841C99.344 12.8241 96.848 9.8961 92.6 9.8961C88.808 9.8961 86.288 12.3921 86.072 16.3521ZM95.888 16.5681C95.888 18.6081 94.592 19.9761 92.672 19.9761C90.728 19.9761 89.48 18.6561 89.48 16.5681C89.48 14.5761 90.776 13.1361 92.672 13.1361C94.592 13.1361 95.888 14.5761 95.888 16.5681Z"
        fill={color}
      />
    </svg>
  );
}
